import styles from "./ClientsAddNewPopup.module.scss";
import React from "react";
import { useTranslation } from "react-i18next";
import { Form } from "antd";
import FormItemInput from "../../../components/ui/FormItemInput/FormItemInput";
import FormItemInputPassword from "../../../components/ui/FormItemInputPassword/FormItemInputPassword";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import { ICreateStaffModel } from "../../../models/Staff";
import { emailValidation, passwordValidation } from "../../../helper/auth";
import { openErrorMessage, openSuccessMessage } from "../../../store/message/messageSlice";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { ClientsService } from "../../../services/clients.service";
import { handleError } from "../../../helper/errorHandler";

interface ClientsAddNewPopupProps {
  clickOnClose: () => void;
}

const ClientsAddNewPopup: React.FC<ClientsAddNewPopupProps> = ({ clickOnClose }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const onFinish = async (values: Omit<ICreateStaffModel, "phoneCountryCode" | "phoneNumber">) => {
    try {
      if (!emailValidation(values.email)) {
        dispatch(openErrorMessage(t("PleaseEnterEmailCorrectly")));
        return;
      }

      if (!passwordValidation(values.password)) {
        dispatch(openErrorMessage(t("ValidationPassword")));
        return;
      }

      const model: Omit<ICreateStaffModel, "phoneCountryCode" | "phoneNumber"> = {
        firstname: values.firstname.trim(),
        lastname: values.lastname.trim(),
        email: values.email.trim(),
        password: values.password.trim(),
      };

      await ClientsService.createClient(model);
      dispatch(openSuccessMessage(t("ProfileCreatedSuccessfully")));
      clickOnClose();
    } catch (e) {
      handleError(e, dispatch, t);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <h3 className={styles.title}>{t("AddNewClient")}</h3>
        <Form
          className={styles.form}
          name="create-client"
          onFinish={onFinish}
          autoComplete={"off"}
          layout={"vertical"}
        >
          <FormItemInput
            name={"firstname"}
            label={t("FirstName") + " *"}
            rules={{ required: true }}
          />
          <FormItemInput
            name={"lastname"}
            label={t("LastName") + " *"}
            rules={{ required: true }}
          />
          <FormItemInput
            name={"email"}
            label={t("EmailAddress") + " *"}
            rules={{ required: true }}
          />
          <FormItemInputPassword
            autoComplete={"new-password"}
            name={"password"}
            label={t("Password") + " *"}
            rules={{ required: true }}
          />

          <div className={styles.btnsWrapper}>
            <CustomButton
              text={t("Close")}
              type={"button"}
              typeStyle={"outline"}
              functionOnClick={clickOnClose}
            />
            <CustomButton text={t("Save")} type={"submit"} typeStyle={"fill"} />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ClientsAddNewPopup;
